
				var addMethods = require("../../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["buildIndex","search"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "5ccb7e24ef25c6a54d07.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			